/* eslint-disable no-param-reassign */
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';

export default function loadResourceSlice(options) {
  const { resource, repository } = options;

  return {
    initialState: {
      [resource]: {
        loadingStatus: FETCH_STATUSES.idle,
        item: null,
        error: null,
      },
    },

    reducers: {
      loadResourceStart(state) {
        state[resource].loadingStatus = FETCH_STATUSES.pending;
        state[resource].item = null;
        state[resource].error = null;
      },
      loadResourceSuccess(state, { payload }) {
        state[resource].loadingStatus = FETCH_STATUSES.fulfilled;
        state[resource].item = payload;
      },
      loadResourceFail(
        state,
        {
          payload: { error },
        },
      ) {
        state[resource].loadingStatus = FETCH_STATUSES.failed;
        state[resource].error = error;
      },
    },

    actionCreators(restDispatch) {
      return {
        loadResource: async (...params) => {
          restDispatch('loadResourceStart');

          try {
            const data = await repository.show(...params);
            restDispatch('loadResourceSuccess', data);

            return data;
          } catch (error) {
            restDispatch('loadResourceFail', { error });
            throw error;
          }
        },
      };
    },
  };
}



// WEBPACK FOOTER //
// ./src/utils/RestSlice/slices/loadResourceSlice.js